import { OmniFileUploadComponent, OmniIconComponent } from "../../../../shared";
import { useTemplateDownload } from "../../hooks/useTemplateDownload";
import { useCampaignFileUpload } from "../../hooks/useCampaignFileUpload";

export const CSVUploadComponent = ({ closeCSVDialog }) => {
  // Template download functionality
  const { downloadTemplate, isDownloading, resetDownload } = useTemplateDownload();
  
  // File upload and parsing functionality
  const { parsedData, isProcessing, handleUpload, resetUpload } = useCampaignFileUpload(() => {
    handleClose();
  });

  const handleClose = () => {
    resetDownload();
    resetUpload();
    closeCSVDialog();
  };

  const isButtonDisabled = !parsedData || isProcessing || isDownloading;

  return (
    <div className="ag-grid-filter-wrapper">
      <omni-modal id="csv-import-modal" className="csv-import-modal">
      <div slot="header">
        <div className="modal-header">
          <p className="modal-header-title">
            Map Planned campaigns to Ordered campaigns
          </p>
          <OmniIconComponent
            icon-id="omni:interactive:close"
            onClick={handleClose}
          />
        </div>
      </div>
      <div className="modal-body">
        <p className="modal-body-title">
          Please follow the below template to import campaign data.
        </p>
        <div className="download-template" onClick={downloadTemplate}>
          <OmniIconComponent icon-id="omni:interactive:download" />
          Download existing planned data.
        </div>
        <OmniFileUploadComponent
          accept=".csv,.xlsx"
          maxFileSize="10485760"
          instructionText="Upload your csv or xlsx file"
          dropTitle="Release to upload"
          description="CSV or XLSX. 10MB max."
          buttonText="Choose file"
          valueMissingMessage="Please upload a file"
          multiple={false}
        />
      </div>
      <div slot="footer" className="modal-footer">
        <button 
          className="cancel-button" 
          onClick={handleClose} 
          disabled={isProcessing || isDownloading}
        >
          Cancel
        </button>
        <button 
          className="upload-button" 
          disabled={isButtonDisabled} 
          onClick={handleUpload}
        >
          {isProcessing ? "Processing..." : isDownloading ? "Downloading..." : "Upload"}
        </button>
      </div>
    </omni-modal>
    </div>
  );
};
